const ANALYTIC_INFO_BY_CONNECTOR_NAME = {
  googleAnalytics: {
    dataSourcePrefix: 'ga',
    dashboardPrefix: 'googleAnalytics',
    dateGroupBreakdown: {
      day: 'ga:date',
      week: 'ga:yearWeek',
      month: 'ga:yearMonth',
    },
    breakdownByLevel: {
      adAccount: 'ga:campaign',
      campaign: 'ga:campaign',
      adSet: 'ga:adContent',
      ad: 'ga:adContent',
      keyword: 'ga:keyword',
    },
    marketingJoinFieldByLevel: {
      adAccount: ['utmSource', 'utmCampaign', 'utmMedium'],
      campaign: ['utmSource', 'utmCampaign', 'utmMedium'],
      adSet: ['utmSource', 'utmCampaign', 'utmMedium', 'utmContent'],
      ad: ['utmSource', 'utmCampaign', 'utmMedium', 'utmContent'],
      keyword: ['utmSource', 'utmCampaign', 'utmMedium', 'keywordName'],
    },
    fieldMapping: {
      utmSource: 'ga:source',
      utmCampaign: 'ga:campaign',
      utmMedium: 'ga:medium',
      utmContent: 'ga:adContent',
      keywordName: 'ga:keyword',
    },
  },
  googleAnalytics4: {
    dataSourcePrefix: 'ga4',
    dashboardPrefix: 'googleAnalytics4',
    dateGroupBreakdown: {
      day: 'day',
      week: 'week',
      month: 'month',
    },
    breakdownByLevel: {
      adAccount: 'ga4:sessionCampaignName',
      campaign: 'ga4:sessionCampaignName',
      adSet: 'ga4:sessionManualAdContent',
      ad: 'ga4:sessionManualAdContent',
      keyword: 'ga4:sessionManualTerm',
    },
    marketingJoinFieldByLevel: {
      adAccount: ['utmSource', 'utmCampaign', 'utmMedium'],
      campaign: ['utmSource', 'utmCampaign', 'utmMedium'],
      adSet: ['utmSource', 'utmCampaign', 'utmMedium', 'utmContent'],
      ad: ['utmSource', 'utmCampaign', 'utmMedium', 'utmContent'],
      keyword: ['utmSource', 'utmCampaign', 'utmMedium', 'utmContent', 'keywordName'],
    },
    fieldMapping: {
      utmSource: 'ga4:sessionSource',
      utmCampaign: 'ga4:sessionCampaignName',
      utmMedium: 'ga4:sessionMedium',
      utmContent: 'ga4:sessionManualAdContent',
      keywordName: 'ga4:sessionManualTerm',
    },
  },
  googleAnalyticsMCF: {
    dataSourcePrefix: 'mcf',
    dashboardPrefix: 'mcf',
    dateGroupBreakdown: {
      day: 'day',
      week: 'week',
      month: 'month',
    },
    breakdownByLevel: {
      adAccount: 'mcf:campaignName',
      campaign: 'mcf:campaignName',
      adSet: 'mcf:campaignName',
      ad: 'mcf:campaignName',
      keyword: 'mcf:keyword',
    },
    marketingJoinFieldByLevel: {
      adAccount: ['utmSource', 'utmCampaign', 'utmMedium'],
      campaign: ['utmSource', 'utmCampaign', 'utmMedium'],
      adSet: ['utmSource', 'utmCampaign', 'utmMedium'],
      ad: ['utmSource', 'utmCampaign', 'utmMedium'],
      keyword: ['utmSource', 'utmCampaign', 'utmMedium', 'utmContent', 'keywordName'],
    },
    fieldMapping: {
      utmSource: 'mcf:source',
      utmCampaign: 'mcf:campaignName',
      utmMedium: 'mcf:medium',
      utmContent: 'notused',
      keywordName: 'mcf:keyword',
    },
  },
  // name mapping
  appsFlyer: {
    dataSourcePrefix: 'af',
    dashboardPrefix: 'appsFlyer',
    breakdownByLevel: {
      adAccount: 'af:campaign',
      campaign: 'af:campaign',
      adSet: 'af:adset',
      ad: 'af:ad',
    },
    marketingJoinFieldByLevel: {
      adAccount: ['campaignNames'],
      campaign: ['campaignName'],
      adSet: ['adSetName'],
      ad: ['adName'],
    },
    fieldMapping: {
      campaignNames: 'af:campaign',
      campaignName: 'af:campaign',
      adSetName: 'af:adset',
      adName: 'af:ad',
    },
  },
  hubspotDeals: {
    dataSourcePrefix: 'hubspotDeals',
    dashboardPrefix: 'hubspotDeals',
    breakdownByLevel: {
      adAccount: 'hubspotDeals:first_utm_source',
      campaign: 'hubspotDeals:first_utm_campaign',
      adSet: 'hubspotDeals:first_utm_medium',
      ad: 'hubspotDeals:first_utm_content',
      keyword: 'hubspotDeals:first_utm_term',
    },
    marketingJoinFieldByLevel: {
      adAccount: ['utmSource', 'utmCampaign', 'utmMedium'],
      campaign: ['utmSource', 'utmCampaign', 'utmMedium'],
      adSet: ['utmSource', 'utmCampaign', 'utmMedium', 'utmContent'],
      ad: ['utmSource', 'utmCampaign', 'utmMedium', 'utmContent'],
      keyword: ['utmSource', 'utmCampaign', 'utmMedium', 'keywordName'],
    },
    fieldMapping: {
      utmSource: 'hubspotDeals:first_utm_source',
      utmCampaign: 'hubspotDeals:first_utm_campaign',
      utmMedium: 'hubspotDeals:first_utm_medium',
      utmContent: 'hubspotDeals:first_utm_content',
      keywordName: 'hubspotDeals:first_utm_term',
    },
  },
  branch: {
    dataSourcePrefix: 'branch',
    dashboardPrefix: 'branch',
    breakdownByLevel: {
      adAccount: 'branch:campaign_id',
      campaign: 'branch:campaign_id',
      adSet: 'branch:adset_id',
      ad: 'branch:ad_id',
    },
    marketingJoinFieldByLevel: {
      adAccount: ['channelCampaignIds'],
      campaign: ['channelCampaignId'],
      adSet: ['channelAdSetId'],
      ad: ['channelAdId'],
    },
    fieldMapping: {
      channelCampaignIds: 'branch:campaign_id',
      channelCampaignId: 'branch:campaign_id',
      channelAdSetId: 'branch:adset_id',
      channelAdId: 'branch:ad_id',
    },
  },
  Adjust: {
    dataSourcePrefix: 'Adjust',
    dashboardPrefix: 'Adjust',
    breakdownByLevel: {
      adAccount: 'Adjust:campaign_id',
      campaign: 'Adjust:campaign_id',
      adSet: 'Adjust:ad_set_id',
      ad: 'Adjust:ad_id',
    },
    marketingJoinFieldByLevel: {
      adAccount: ['channelCampaignIds'],
      campaign: ['channelCampaignId'],
      adSet: ['channelAdSetId'],
      ad: ['channelAdId'],
    },
    fieldMapping: {
      channelCampaignIds: 'Adjust:campaign_id',
      channelCampaignId: 'Adjust:campaign_id',
      channelAdSetId: 'Adjust:ad_set_id',
      channelAdId: 'Adjust:ad_id',
    },
  },
  Singular: {
    dataSourcePrefix: 'Singular',
    dashboardPrefix: 'Singular',
    breakdownByLevel: {
      adAccount: 'Singular:unified_campaign_name',
      campaign: 'Singular:unified_campaign_name',
      adSet: 'Singular:unified_campaign_name',
      ad: 'Singular:unified_campaign_name',
    },
    marketingJoinFieldByLevel: {
      adAccount: ['campaignNames'],
      campaign: ['campaignName'],
      adSet: ['campaignName'],
      ad: ['campaignName'],
    },
    fieldMapping: {
      campaignNames: 'Singular:unified_campaign_name',
      campaignName: 'Singular:unified_campaign_name',
    },
  },
};

ANALYTIC_INFO_BY_CONNECTOR_NAME.googleAnalytics.getAnalyticsFieldToField = (analyticField, dataSource) => {
  let field = analyticField
    .replace(
      ANALYTIC_INFO_BY_CONNECTOR_NAME.googleAnalytics.dashboardPrefix,
      ANALYTIC_INFO_BY_CONNECTOR_NAME.googleAnalytics.dataSourcePrefix,
    )
    .replace(':' + dataSource.dataSourceName, '');
  if (analyticField.startsWith('conversions:ga')) {
    field = field.replace('conversions:ga:', 'ga:goal') + 'Completions';
  } else if (analyticField.startsWith('conversionRate:ga')) {
    field = field.replace('conversionRate:ga:', 'ga:goal') + 'ConversionRate';
  }
  if (analyticField.startsWith('conversions:googleAnalytics')) {
    field = field.replace('conversions:googleAnalytics:', 'ga:goal') + 'Completions';
  } else if (analyticField.startsWith('conversionRate:googleAnalytics')) {
    field = field.replace('conversionRate:googleAnalytics:', 'ga:goal') + 'ConversionRate';
  }
  return field;
};

ANALYTIC_INFO_BY_CONNECTOR_NAME.googleAnalytics4.getAnalyticsFieldToField = (analyticField, dataSource) => {
  let field = analyticField;
  field = field
    .replace(
      ANALYTIC_INFO_BY_CONNECTOR_NAME.googleAnalytics4.dashboardPrefix,
      ANALYTIC_INFO_BY_CONNECTOR_NAME.googleAnalytics4.dataSourcePrefix,
    )
    .replace(':' + dataSource.dataSourceName, '');
  return field;
};

ANALYTIC_INFO_BY_CONNECTOR_NAME.googleAnalyticsMCF.getAnalyticsFieldToField = (analyticField, dataSource) => {
  let field = analyticField;
  field = field
    .replace(
      ANALYTIC_INFO_BY_CONNECTOR_NAME.googleAnalyticsMCF.dashboardPrefix,
      ANALYTIC_INFO_BY_CONNECTOR_NAME.googleAnalyticsMCF.dataSourcePrefix,
    )
    .replace(':' + dataSource.dataSourceName, '');
  return field;
};

ANALYTIC_INFO_BY_CONNECTOR_NAME.appsFlyer.getAnalyticsFieldToField = (analyticField, dataSource) => {
  let field = analyticField;
  field = field
    .replace(
      ANALYTIC_INFO_BY_CONNECTOR_NAME.appsFlyer.dashboardPrefix,
      ANALYTIC_INFO_BY_CONNECTOR_NAME.appsFlyer.dataSourcePrefix,
    )
    .replace(':' + dataSource.dataSourceId, '');
  return field;
};

ANALYTIC_INFO_BY_CONNECTOR_NAME.branch.getAnalyticsFieldToField = (analyticField, dataSource) => {
  let field = analyticField;
  field = field
    .replace(
      ANALYTIC_INFO_BY_CONNECTOR_NAME.branch.dashboardPrefix,
      ANALYTIC_INFO_BY_CONNECTOR_NAME.branch.dataSourcePrefix,
    )
    .replace(':' + dataSource.dataSourceName, '');
  return field;
};

ANALYTIC_INFO_BY_CONNECTOR_NAME.Adjust.getAnalyticsFieldToField = (analyticField, dataSource) => {
  let field = analyticField;
  field = field
    .replace(
      ANALYTIC_INFO_BY_CONNECTOR_NAME.Adjust.dashboardPrefix,
      ANALYTIC_INFO_BY_CONNECTOR_NAME.Adjust.dataSourcePrefix,
    )
    .replace(':' + dataSource.dataSourceName, '');
  return field;
};

ANALYTIC_INFO_BY_CONNECTOR_NAME.Singular.getAnalyticsFieldToField = (analyticField, dataSource) => {
  let field = analyticField;
  field = field
    .replace(
      ANALYTIC_INFO_BY_CONNECTOR_NAME.Singular.dashboardPrefix,
      ANALYTIC_INFO_BY_CONNECTOR_NAME.Singular.dataSourcePrefix,
    )
    .replace(':' + dataSource.dataSourceName, '');
  return field;
};

ANALYTIC_INFO_BY_CONNECTOR_NAME.hubspotDeals.getAnalyticsFieldToField = (analyticField, dataSource) => {
  let field = analyticField;
  field = field
    .replace(
      ANALYTIC_INFO_BY_CONNECTOR_NAME.hubspotDeals.dashboardPrefix,
      ANALYTIC_INFO_BY_CONNECTOR_NAME.hubspotDeals.dataSourcePrefix,
    )
    .replace(':' + dataSource.dataSourceName, '');
  return field;
};

function getConnectorName(dataSource) {
  let connectorName = dataSource.connectorName;
  if (connectorName === 'adverity') {
    connectorName = dataSource.adverityExtra.adverityChannelName;
  }
  if (connectorName === 'csvWithDate') {
    connectorName = dataSource.dataSourceName;
  }
  return connectorName;
}
function getAnalyticsInfo(dataSource) {
  const connectorName = getConnectorName(dataSource);
  return ANALYTIC_INFO_BY_CONNECTOR_NAME[connectorName];
}

function getDataSourceFields(dataSource, fields, dashboardPrefix) {
  const connectorName = getConnectorName(dataSource);
  return (fields || []).filter(
    field =>
      field.includes(':') &&
      (field.includes(connectorName) || field.split(':')[0] == dashboardPrefix) &&
      (connectorName == 'branch' ||
        field.includes(dataSource.dataSourceName) ||
        field.includes(dataSource.dataSourceId)),
  );
}

function isAnalyticDataSource(dataSource) {
  return (
    dataSource.dataSourceType === 'analytic' ||
    (dataSource.connectorName === 'adverity' &&
      ANALYTIC_INFO_BY_CONNECTOR_NAME.hasOwnProperty(dataSource?.adverityExtra?.adverityChannelName))
  );
}
module.exports = { ANALYTIC_INFO_BY_CONNECTOR_NAME, getAnalyticsInfo, getDataSourceFields, isAnalyticDataSource };
